// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.login {
    display: flex;
    width: 100%;
    height: 100vh;
    background: #FFFFFF;
    justify-content: center;
    font-family: 'Roboto';
}

.icon_bg {
    position: relative;
    width: 700px;
    height: 700px;
    left: -300px;
    top: 100px;
    fill: #AAAAAA;
    }

.background_box {
    position: absolute;
    margin-top: 60px;
    width: 1200px;
    height: 770px;
    background: #041643;
    opacity: 0.9;
    border-radius: 40px;
}

.logo {
    position: relative;
    display: flex;
    text-align: start;
    align-items: center;
    top: 115px;
    left: 160px;
    font-size: 25px;
    font-weight: 700;
    color: #FFFFFF;
}

.logo_icon {
    width: 40px;
    height: 40px;
    fill: #6b8be2;
}

.guide_text {
    position: relative;
    left: 150px;
    top: 300px;
    text-align: start;
    font-size: 27px;
    font-weight: 700;
    color: #FFFFFF;
}

.login_box {
    position: absolute;
    left: 620px;
    top: 230px;
    width: 430px;
    height: 420px;
    background: #FFFFFF;
    border-radius: 14px;
}

.email_area {
    position: relative;
    margin-left: 30px;
    margin-top: 63px;
    width: 360px;
    height: 50px;
    padding: 0px;
}

.password_area {
    position: relative;
    margin-left: 30px;
    margin-top: 40px;
    width: 360px;
    height: 50px;
    padding: 0px;
}

.input_header {
    text-align: start;
    font-size: 10px;
}

.text_input {
    border: 1px solid #D7D7D7;
    border-radius: 5px;
    width: 330px;
    height: 42px;
    padding: 0px 15px;
}

.text_input::placeholder {
    color: #C8C8C8;
    opacity: 1;
    /* Firefox */
}

.button_area {
    position: relative;
    display: flex;
    justify-content: space-between;
    left: 30px;
    width: 362px;
    margin-top: 50px;
    align-items: center;
}
.registration_guide_area {
    text-align: start;
}
.registration_guide {
    font-size: 12px;
    margin-bottom: 5px;
}

.registration_guide a {
    font-size: 12px;
    font-weight: 700;
}

.login_button {
    text-align: center;
    width: 127px;
    height: 36px;
    color: #FFFFFF;
    font-size: 12px;
    background: #1352F1;
    border-radius: 7px;
    line-height: 36px;
    cursor: pointer;
}

.registration_box {
    position: absolute;
    left: 620px;
    top: 100px;
    width: 430px;
    height: 540px;
    background: #FFFFFF;
    border-radius: 14px;
}

.back_button {
    position: absolute;
    top: 20px;
    left : 20px;
    width: 50px;
    height: 50px;
    cursor: pointer;
    stroke: #FFFFFF;
}

.registration_button {
    text-align: center;
    width: 127px;
    height: 36px;
    color: #FFFFFF;
    font-size: 12px;
    background: #1352F1;
    border-radius: 7px;
    line-height: 36px;
    margin-left: 230px;
    cursor: pointer;
}
.vertical_divider {
    height: 1px;
    background-color: #0077b6;
    margin-top: 15px;
    margin-left: 10px;
    margin-right: 10px;
}
.social_login_area {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    margin-top: 20px;
}
.social_login_button {
    cursor: pointer;
    display: flex;
    width: 50px;
    height: 50px;
    justify-content: center;
    align-items: center;
    background-color: transparent;
    border: none;
}
.social_login_icon {
    width: 40px;
    height: 40px;
}`, "",{"version":3,"sources":["webpack://./src/css/login.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,WAAW;IACX,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,qBAAqB;AACzB;;AAEA;IACI,kBAAkB;IAClB,YAAY;IACZ,aAAa;IACb,YAAY;IACZ,UAAU;IACV,aAAa;IACb;;AAEJ;IACI,kBAAkB;IAClB,gBAAgB;IAChB,aAAa;IACb,aAAa;IACb,mBAAmB;IACnB,YAAY;IACZ,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,aAAa;IACb,iBAAiB;IACjB,mBAAmB;IACnB,UAAU;IACV,WAAW;IACX,eAAe;IACf,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,aAAa;AACjB;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,UAAU;IACV,iBAAiB;IACjB,eAAe;IACf,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,UAAU;IACV,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,iBAAiB;IACjB,gBAAgB;IAChB,YAAY;IACZ,YAAY;IACZ,YAAY;AAChB;;AAEA;IACI,kBAAkB;IAClB,iBAAiB;IACjB,gBAAgB;IAChB,YAAY;IACZ,YAAY;IACZ,YAAY;AAChB;;AAEA;IACI,iBAAiB;IACjB,eAAe;AACnB;;AAEA;IACI,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,YAAY;IACZ,iBAAiB;AACrB;;AAEA;IACI,cAAc;IACd,UAAU;IACV,YAAY;AAChB;;AAEA;IACI,kBAAkB;IAClB,aAAa;IACb,8BAA8B;IAC9B,UAAU;IACV,YAAY;IACZ,gBAAgB;IAChB,mBAAmB;AACvB;AACA;IACI,iBAAiB;AACrB;AACA;IACI,eAAe;IACf,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,YAAY;IACZ,YAAY;IACZ,cAAc;IACd,eAAe;IACf,mBAAmB;IACnB,kBAAkB;IAClB,iBAAiB;IACjB,eAAe;AACnB;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,UAAU;IACV,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,WAAW;IACX,WAAW;IACX,YAAY;IACZ,eAAe;IACf,eAAe;AACnB;;AAEA;IACI,kBAAkB;IAClB,YAAY;IACZ,YAAY;IACZ,cAAc;IACd,eAAe;IACf,mBAAmB;IACnB,kBAAkB;IAClB,iBAAiB;IACjB,kBAAkB;IAClB,eAAe;AACnB;AACA;IACI,WAAW;IACX,yBAAyB;IACzB,gBAAgB;IAChB,iBAAiB;IACjB,kBAAkB;AACtB;AACA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,QAAQ;IACR,gBAAgB;AACpB;AACA;IACI,eAAe;IACf,aAAa;IACb,WAAW;IACX,YAAY;IACZ,uBAAuB;IACvB,mBAAmB;IACnB,6BAA6B;IAC7B,YAAY;AAChB;AACA;IACI,WAAW;IACX,YAAY;AAChB","sourcesContent":[".login {\r\n    display: flex;\r\n    width: 100%;\r\n    height: 100vh;\r\n    background: #FFFFFF;\r\n    justify-content: center;\r\n    font-family: 'Roboto';\r\n}\r\n\r\n.icon_bg {\r\n    position: relative;\r\n    width: 700px;\r\n    height: 700px;\r\n    left: -300px;\r\n    top: 100px;\r\n    fill: #AAAAAA;\r\n    }\r\n\r\n.background_box {\r\n    position: absolute;\r\n    margin-top: 60px;\r\n    width: 1200px;\r\n    height: 770px;\r\n    background: #041643;\r\n    opacity: 0.9;\r\n    border-radius: 40px;\r\n}\r\n\r\n.logo {\r\n    position: relative;\r\n    display: flex;\r\n    text-align: start;\r\n    align-items: center;\r\n    top: 115px;\r\n    left: 160px;\r\n    font-size: 25px;\r\n    font-weight: 700;\r\n    color: #FFFFFF;\r\n}\r\n\r\n.logo_icon {\r\n    width: 40px;\r\n    height: 40px;\r\n    fill: #6b8be2;\r\n}\r\n\r\n.guide_text {\r\n    position: relative;\r\n    left: 150px;\r\n    top: 300px;\r\n    text-align: start;\r\n    font-size: 27px;\r\n    font-weight: 700;\r\n    color: #FFFFFF;\r\n}\r\n\r\n.login_box {\r\n    position: absolute;\r\n    left: 620px;\r\n    top: 230px;\r\n    width: 430px;\r\n    height: 420px;\r\n    background: #FFFFFF;\r\n    border-radius: 14px;\r\n}\r\n\r\n.email_area {\r\n    position: relative;\r\n    margin-left: 30px;\r\n    margin-top: 63px;\r\n    width: 360px;\r\n    height: 50px;\r\n    padding: 0px;\r\n}\r\n\r\n.password_area {\r\n    position: relative;\r\n    margin-left: 30px;\r\n    margin-top: 40px;\r\n    width: 360px;\r\n    height: 50px;\r\n    padding: 0px;\r\n}\r\n\r\n.input_header {\r\n    text-align: start;\r\n    font-size: 10px;\r\n}\r\n\r\n.text_input {\r\n    border: 1px solid #D7D7D7;\r\n    border-radius: 5px;\r\n    width: 330px;\r\n    height: 42px;\r\n    padding: 0px 15px;\r\n}\r\n\r\n.text_input::placeholder {\r\n    color: #C8C8C8;\r\n    opacity: 1;\r\n    /* Firefox */\r\n}\r\n\r\n.button_area {\r\n    position: relative;\r\n    display: flex;\r\n    justify-content: space-between;\r\n    left: 30px;\r\n    width: 362px;\r\n    margin-top: 50px;\r\n    align-items: center;\r\n}\r\n.registration_guide_area {\r\n    text-align: start;\r\n}\r\n.registration_guide {\r\n    font-size: 12px;\r\n    margin-bottom: 5px;\r\n}\r\n\r\n.registration_guide a {\r\n    font-size: 12px;\r\n    font-weight: 700;\r\n}\r\n\r\n.login_button {\r\n    text-align: center;\r\n    width: 127px;\r\n    height: 36px;\r\n    color: #FFFFFF;\r\n    font-size: 12px;\r\n    background: #1352F1;\r\n    border-radius: 7px;\r\n    line-height: 36px;\r\n    cursor: pointer;\r\n}\r\n\r\n.registration_box {\r\n    position: absolute;\r\n    left: 620px;\r\n    top: 100px;\r\n    width: 430px;\r\n    height: 540px;\r\n    background: #FFFFFF;\r\n    border-radius: 14px;\r\n}\r\n\r\n.back_button {\r\n    position: absolute;\r\n    top: 20px;\r\n    left : 20px;\r\n    width: 50px;\r\n    height: 50px;\r\n    cursor: pointer;\r\n    stroke: #FFFFFF;\r\n}\r\n\r\n.registration_button {\r\n    text-align: center;\r\n    width: 127px;\r\n    height: 36px;\r\n    color: #FFFFFF;\r\n    font-size: 12px;\r\n    background: #1352F1;\r\n    border-radius: 7px;\r\n    line-height: 36px;\r\n    margin-left: 230px;\r\n    cursor: pointer;\r\n}\r\n.vertical_divider {\r\n    height: 1px;\r\n    background-color: #0077b6;\r\n    margin-top: 15px;\r\n    margin-left: 10px;\r\n    margin-right: 10px;\r\n}\r\n.social_login_area {\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    gap: 8px;\r\n    margin-top: 20px;\r\n}\r\n.social_login_button {\r\n    cursor: pointer;\r\n    display: flex;\r\n    width: 50px;\r\n    height: 50px;\r\n    justify-content: center;\r\n    align-items: center;\r\n    background-color: transparent;\r\n    border: none;\r\n}\r\n.social_login_icon {\r\n    width: 40px;\r\n    height: 40px;\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
